/* eslint-disable */
export default {
  mute: '음소거',
  unmute: '음소거 해제',
  hangup: '전화 끊기',
  reject: '거부',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
